<template>
  <div class="asd-form-section">
    <div class="section-title">
      <h5>
        <i class="fas fa-envelope"></i>
        Šablony
      </h5>
    </div>
    <table class="asd-table">
      <thead>
        <tr class="table-heading">
          <th>
          </th>
          <th>
            Název šablony
          </th>
          <th>
            Typ obsahu
          </th>
          <th>
            Kód
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="t in templates"
            :key="t.id"
        >
          <td class="asd-btn-group">
            <button v-help.mouse="`Editovat šablonu`"
                    type="button"
                    class="asd-btn-edit"
                    @click="$router.push({name: 'settingsCompanyTemplateDetail', params: {id: t.id}})"
            >
              <i class="fas fa-pencil-alt"></i>
            </button>
          </td>
          <td>
            {{ t.name }}
          </td>
          <td>
            {{ contentTypeText(t.contentType) }}
          </td>
          <td>
            {{ t.templateCode }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import EventBus from 'CORE/bus'
import contentTypes from 'ENUMS/template-content-types'
import { find, get } from 'lodash'

export default {
    name: 'SettingsComapnyTemplateTable',
    data() {
        return {
            states: [],
        }
    },
    computed: {
        templates() {
            return this.$store.getters.companyTemplates
        },
    },
    methods: {
        contentTypeText(code) {
            return get(find(contentTypes, ct => ct.key === code), 'label', '---')
        },
        async deleteTemplate(template) {
            try {
                await this.$store.dispatch('companyTemplatesDelete', template)
                await this.$store.dispatch('companyTemplatesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Vymazano' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async addTemplate() {

        },
    },
}
</script>

<style scoped>

</style>

